import { render } from "./SuccessSubmit.vue?vue&type=template&id=5f7b1ce4&scoped=true"
import script from "./SuccessSubmit.vue?vue&type=script&lang=js"
export * from "./SuccessSubmit.vue?vue&type=script&lang=js"

import "./SuccessSubmit.vue?vue&type=style&index=0&id=5f7b1ce4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f7b1ce4"]])

export default __exports__